@switch (parentFilterValue) {
    @case (notificationStatusEnum.SUCCESS) {
        <div
            class="statusWrapper live"
            title="{{ 'notifications.statuses.tooltips.SUCCESS' | translate }}"
            [ngClass]="{ 'small-icon': isFloatingFilterIcon }"
        >
            <i class="fas fa-check"></i>
        </div>
    }
    @case (notificationStatusEnum.IN_PROGRESS) {
        <div
            class="statusWrapper submitted-publish"
            title="{{ 'notifications.statuses.tooltips.IN_PROGRESS' | translate }}"
            [ngClass]="{ 'small-icon': isFloatingFilterIcon }"
        >
            <i class="fas fa-loader"></i>
        </div>
    }
    @case (notificationStatusEnum.WARNING) {
        <div
            class="statusWrapper submitted-publish"
            title="{{ 'notifications.statuses.tooltips.WARNING' | translate }}"
            [ngClass]="{ 'small-icon': isFloatingFilterIcon }"
        >
            <i class="fas fa-triangle-exclamation"></i>
        </div>
    }
    @case (notificationStatusEnum.ERROR) {
        <div
            class="statusWrapper publish-failure"
            title="{{ 'notifications.statuses.tooltips.ERROR' | translate }}"
            [ngClass]="{ 'small-icon': isFloatingFilterIcon }"
        >
            <i class="fas fa-triangle-exclamation"></i>
        </div>
    }
    @case (null) {
        <div class="statusWrapper" title="Unknown" [ngClass]="{ 'small-icon': isFloatingFilterIcon }">
            <i class="fas fa-question"></i>
        </div>
    }
}
@if (isFloatingFilterIcon) {
    {{ 'notifications.statuses.tooltips.' + parentFilterValue | translate }}
}
